import { Routes } from "@angular/router";
import { BlankComponent } from "./layouts/blank/blank.component";
import { FullComponent } from "./layouts/full/full.component";
import { AuthGuard } from "./services/auth.guard";
import { pendingOrderResolver } from "./pages/pending-orders/pending-order/pending-order.resolver";
import { pullSheetResolver } from "./pages/pull-sheet/pull-sheet.resolver";
import { billOfLandingResolver } from "./pages/bill-of-landing/bill-of-landing.resolver";
import { saleOrderResolver } from "./pages/sale-order/sale-order.resolver";

export const routes: Routes = [
  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        redirectTo: "/dashboard",
        pathMatch: "full",
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./pages/pages.routes").then((m) => m.PagesRoutes),
      },

      {
        path: "pending_orders",
        resolve: { pendingOrderResolver },
        loadComponent: () =>
          import(
            "./pages/pending-orders/pending-order/pending-order.component"
          ).then((m) => m.PendingOrderComponent),

        data: {
          title: "Pending Orders",
          urls: [{ title: "Pending Orders", url: "/pending_orders" }],
        },
      },
      {
        path: "pull_sheet",
        resolve: { pullSheetResolver },
        loadComponent: () =>
          import("./pages/pull-sheet/pull-sheet.component").then(
            (m) => m.PullSheetComponent
          ),

        data: {
          title: "Pull Sheet",
          urls: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Pull Sheet", url: "/pull-sheet" },
          ],
        },
      },
      {
        path: "bill_of_landing",
        resolve: { billOfLandingResolver },
        loadComponent: () =>
          import("./pages/bill-of-landing/bill-of-landing.component").then(
            (m) => m.BillOfLandingComponent
          ),

        data: {
          title: "Bill of Landing",
          urls: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Bill of Landing", url: "/bill_of_landing" },
          ],
        },
      },
      {
        path: "sale-orders",
        resolve: { saleOrderResolver },
        loadComponent: () =>
          import("./pages/sale-order/sale-order.component").then(
            (m) => m.SaleOrderComponent
          ),

        data: {
          title: "Sale Orders",
          urls: [
            { title: "Dashboard", url: "/dashboard" },
            { title: "Sale Orders", url: "/sale-orders" },
          ],
        },
      },
    ],
  },

  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "authentication",
        loadChildren: () =>
          import("./pages/authentication/authentication.routes").then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "authentication/error",
  },
];
